// extracted by mini-css-extract-plugin
export default {"button":"styles_button__C9i2Q","textButton":"styles_textButton__BSvOR","spinner":"styles_spinner__eH7eb"};